@if(formGroup.get('deliverTo')){
<form [formGroup]="getFormGroup()">
  <div class="p-2">
    <div class="mb-2 mogo-header-2 text-start p-2 border-bottom">
      Deliver To Information
    </div>
    <div class="m-4 mt-3">
      <app-address-picker [formGroup]="getFormGroup()" label="Deliver To"  [showPreciseLocationOptions]="true" preciseLocationLabel="Deliver To Location"></app-address-picker>
      <div class="row mb-1">
        <label class="col-3 mt-2 text-start mogo-bold" for="delivery-date-input">Delivery Date:</label>
        <div class="col-9" formGroupName="deliverDateTime">
          <div class="row">
            <div class="col-8">
              <div class="input-group">
                <input class="form-control required" placeholder="Delivery Date" name="dp" formControlName="date"
                  ngbDatepicker #deliveryPicker="ngbDatepicker" removeNgbDpDefaultValidation id="delivery-date-input" autocomplete="off"/>
                <button class="btn btn-outline-secondary py-1" (click)="deliveryPicker.toggle()" [disabled]="lockdown"
                  type="button">
                  <ng-icon name="bootstrapCalendarFill" size></ng-icon>
                </button>
              </div>
            </div>
            <div class="col-4">
              <ngb-timepicker id="delivery-time-picker" [size]="'small'" formControlName="time" [meridian]="true"
                [spinners]="false"></ngb-timepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-1">
        <label class="col-3 mt-2 text-start mogo-bold" for="deliver-to-input">Instructions:</label>
        <div class="col-9">

          <textarea id="deliver-to-input" type="text" class="form-control required" formControlName="instructions"
            placeholder="Instructions"> </textarea>
        </div>

      </div>
      <div class="row mb-1">
        <label class="col-3 mt-2 text-start mogo-bold">Site Contact:</label>
        <div class="col-9">
          <input id="site-contact-input" type="text" class="form-control" formControlName="siteContact"
            placeholder="Site Contact" (change)="customerContactNameAltered()" />
        </div>
      </div>
      <div class="row mb-1">
        <label class="col-3 mt-2 text-start mogo-bold">Contact Phone:</label>
        <div class="col-9">
          <input id="site-contact-input" type="text" class="form-control" formControlName="siteContactPhone"
            placeholder="Contact Phone" (change)="customerContactPhoneAltered()" />
        </div>
      </div>
      <div class="row mb-1">
        <label class="col-3 mt-2 text-start mogo-bold">Contact Email:</label>
        <div class="col-9">
          <input id="site-contact-input" type="text" class="form-control" formControlName="siteContactEmail"
            placeholder="Contact Email" />
            @if(formGroup.get('deliverTo')?.get('siteContactEmail')?.invalid && formGroup.get('deliverTo')?.get('siteContactEmail')?.touched){
              <div class="text-start">
                <small class="text-danger">Please enter a valid email address</small>
              </div>
            }
        </div>
      </div>
    </div>
  </div>
</form>
}
